function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#23C386",
  d: "M0 30v-9h134v9z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#29B587",
  d: "M138 48v-9h117v9zm-4-18v-9h188v9zM31 12V3h26v9z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#2BA691",
  d: "M254 48v-9h10v9zm-28-9v-9h29v9zm-92-18v-9h47v9zm-77-9V3h46v9z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A8F9D",
  d: "M126 57v-9h11v9zm138-9v-9h92v9zm-10-9v-9h81v9zM103 12V3h22v9z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#285D99",
  d: "M628 30v-9h172v9zm-444-9v-9h40v9zm-59-9V3h42v9z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#2B4697",
  d: "M455 39v-9h159v9z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#2E3195",
  d: "M871 30v-9h43v9zM188 12V3h37v9z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#512D93",
  d: "M276 57v-9h36v9zm337-9v-9h36v9z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#7A3390",
  d: "M914 30v-9h165v9z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#512D93",
  d: "M351 21v-9h23v9z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#6C2E92",
  d: "M311 57v-9zm338-9v-9h94v9z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#7A3390",
  d: "M741 48v-9h61v9zm140-9v-9h133v9zM413 21v-9h112v9z"
});

function SvgDividerBlockLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1079 57",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, /*#__PURE__*/React.createElement("path", {
    d: "M71.5 53.5v-8h-66v8h66zm71-9v-8H5.5v8h137zm0-9v-8H5.5v8h137zm-88-18v-8h-49v8h49zm-19-9v-8h-30v8h30z",
    stroke: "#23C386",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.5 53.5v-8h-46v8h46zm114-18v-8h-89v8h89zm-93-18v-8h-83v8h83z",
    stroke: "#29B587",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.5 53.5v-8h-12v8h12zm366-27v-8h-169v8h169z",
    stroke: "#2BA691",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.5 26.5v-8h-135v8h135zm-443-9v-8h-3v8h3z",
    stroke: "#2A8F9D",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.5 53.5v-8h-57v8h57zm269-9v-8h-106v8h106zm-8-9v-8h-119v8h119z",
    stroke: "#285D99",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.5 53.5v-8h-58v8h58zm260-9v-8h-49v8h49zm360-18v-8h-72v8h72zm-599-9v-8h-49v8h49zm-86-9v-8h-21v8h21z",
    stroke: "#2B4697",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.5 53.5v-8h-24v8h24zm336-9v-8h-99v8h99zm32-9v-8h-30v8h30zm-293-18v-8h-77v8h77z",
    stroke: "#2E3195",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.5 35.5v-8h-68v8h68zm-476-27v-8h-11v8h11z",
    stroke: "#512D93",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.5 35.5v-8h-168v8h168zm-468-18v-8h-38v8h38zm-140-9v-8h-35v8h35z",
    stroke: "#6C2E92",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.5 53.5v-8h-38v8h38zm-52-45v-8h-25v8h25z",
    stroke: "#7A3390",
    style: {
      mixBlendMode: "screen"
    }
  })));
}

export default "data:image/svg+xml;base64,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";
export { SvgDividerBlockLeft as ReactComponent };